// extracted by mini-css-extract-plugin
module.exports = {"current":"AppManager_current__KtsoG","active":"AppManager_active___IRl6"};